import { PedalOrder } from '../../type/desktop';
export const DEFAULT_PEDAL_AUTOMATIC_REWIND = 3;
export const DEFAULT_PEDAL_ORDER = PedalOrder.Rewind_Play_Forward;
export const DEFAULT_SHOW_MFA_SETUP = true;
export class UserSettings {
}
